import { Button, VbzDivider } from '@smiles/voebiz-ui-kit';
import dayjs from 'dayjs';
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useBeneficiaries } from '../../contexts/Beneficiaries';
import CalendarMui from '../CalendarMui';
import { Checkbox } from '../Checkbox';
import DrawerModal from '../DrawerModal';

interface ModalFilterProps {
  isOpen: boolean;
  closeModal(): void;
}

const ModalFilter: FC<ModalFilterProps> = ({ isOpen = false, closeModal }) => {
  const { t } = useTranslation(['modalInclude', 'summary']);

  const { filter, setFilter } = useBeneficiaries();

  const [createdStart, setCreatedStart] = useState<dayjs.Dayjs | null>(null);

  const [hasValueToFilter, setHasValueToFilter] = useState(false);

  const [createdEnd, setCreatedEnd] = useState<dayjs.Dayjs | null>(null);

  const [birthStart, setBirthStart] = useState<dayjs.Dayjs | null>(null);

  const [birthEnd, setBirthdEnd] = useState<dayjs.Dayjs | null>(null);

  const [status, setStatus] = useState<string | undefined>(filter?.status);

  const formatStartDate = (date: dayjs.Dayjs) => (date ? dayjs(date).startOf('month').format('MM/DD/YYYY') : null);

  const formatEndDate = (date: dayjs.Dayjs) => (date ? dayjs(date).endOf('month').format('MM/DD/YYYY') : null);

  const handleApplyFilter = () => {
    const payload = {
      createdStart: formatStartDate(createdStart),
      createdEnd: formatEndDate(createdEnd),
      birthStart: formatStartDate(birthStart),
      birthEnd: formatEndDate(birthEnd),
      status,
    };
    setFilter(payload);
    closeModal();
  };

  useEffect(() => {
    const isEmptyCreated = !(createdStart && createdEnd);

    const isEmptyBirth = !(birthStart && birthEnd);

    const isEmptyStatus = !status && !filter?.status;

    const enable = !isEmptyCreated || !isEmptyBirth || !isEmptyStatus;

    setHasValueToFilter(enable);
  }, [birthEnd, birthStart, createdEnd, createdStart, status, filter?.status]);

  useEffect(() => {
    setCreatedStart(filter?.createdStart ? dayjs(filter?.createdStart) : null);

    setCreatedEnd(filter?.createdEnd ? dayjs(filter?.createdEnd) : null);

    setBirthStart(filter?.birthStart ? dayjs(filter?.birthStart) : null);

    setBirthdEnd(filter?.birthEnd ? dayjs(filter?.birthEnd) : null);
  }, [filter]);

  return (
    <DrawerModal id="filter-beneficiaries" open={isOpen} anchor="right" onClose={() => closeModal()}>
      <div className="texts-beneficiaries">
        <div>
          <h3 className="beneficiary-filter-title">{t('filter')}</h3>
          <p className="beneficiary-filter-label">{t('inclusion_date_other')}</p>
          <p className="beneficiary-filter-text">{t('select_period')}</p>
          <div className="calenderfilter beneficiaries-filter" data-testid="created-range">
            <CalendarMui
              className="left"
              label={t('from')}
              views={['month', 'year']}
              format="MMM YYYY"
              maxDate={dayjs()}
              value={createdStart}
              onChange={(newValue) => setCreatedStart(newValue)}
            />
            <CalendarMui
              className="right"
              label={t('to')}
              data-testid="end-date"
              views={['month', 'year']}
              format="MMM YYYY"
              minDate={createdStart}
              value={createdEnd}
              onChange={(newValue) => setCreatedEnd(newValue)}
            />
          </div>
        </div>
        <VbzDivider className="modaldivider" height={undefined} />
        <div>
          <p className="beneficiary-filter-label">{t('status')}</p>
          <p className="beneficiary-filter-text">{t('select_status')}</p>
          <Checkbox change={setStatus} status={filter?.status} />
        </div>
        <VbzDivider className="modaldivider" />
        <div>
          <p className="beneficiary-filter-label">{t('birthday_date')}</p>
          <p className="beneficiary-filter-text">{t('select_period')}</p>
          <div className="calenderfilter beneficiaries-filter">
            <CalendarMui
              className="left"
              label={t('from')}
              views={['month', 'year']}
              format="MMM YYYY"
              maxDate={dayjs()}
              value={birthStart}
              onChange={(newValue) => setBirthStart(newValue)}
            />
            <CalendarMui
              className="right"
              label={t('to')}
              views={['month', 'year']}
              format="MMM YYYY"
              minDate={birthStart}
              value={birthEnd}
              onChange={(newValue) => setBirthdEnd(newValue)}
            />
          </div>
        </div>
        <Button
          data-testid="button-apply-filter"
          disabled={!hasValueToFilter}
          className="buttonmodal"
          onClick={handleApplyFilter}
        >
          {t('go_filter')}
        </Button>

        <button className="underlined-back" type="button" onClick={closeModal}>
          {t('go_back')}
        </button>
      </div>
    </DrawerModal>
  );
};

export default ModalFilter;
